import {arrowUpCircleSvg as Icon__small__arrowUpCircleSvg} from '../Icon__small/Icon__small--arrowUpCircle.js';

export var arrowUpCircle = {
  name: 'arrowUpCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowUpCircleSvg,
};
